export enum FIELD_NAMES {
  EMAIL = "email",
  PASSWORD = "password",
  FIRST_NAME = "firstName",
  LAST_NAME = "lastName",
}

export const MAX_FORM_FIELDS_LENGTH = 24;
export const MIN_PASSWORD_LENGTH = 6;
